import { render } from "./ShopPerformanceSkeleton.vue?vue&type=template&id=4f466716"
import script from "./ShopPerformanceSkeleton.vue?vue&type=script&lang=js"
export * from "./ShopPerformanceSkeleton.vue?vue&type=script&lang=js"

import "./ShopPerformanceSkeleton.vue?vue&type=style&index=0&id=4f466716&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__